<div class="fullsize-vbox" style="gap: 2px;">
    <wj-flex-grid #grid
                  (initialized)="onGridInitialized(grid, gridFilter)"
                  [showSelectedHeaders]="Wijmo.HeadersVisibility.Column"
                  [showMarquee]="true" width="100%" height="100%"
                  [allowResizing]="Wijmo.AllowResizing.None" [autoRowHeights]="false" [quickAutoSize]="false"
                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.Row" [isReadOnly]="true"
                  [autoGenerateColumns]="false"
                  (dblclick)="onRowDblClick($event)"
    >
        <wj-flex-grid-filter #gridFilter></wj-flex-grid-filter>
    </wj-flex-grid>

    <div class="layout-hbox" style="align-items: center; justify-content: flex-end; grid-gap: 10px;">
        <wj-flex-grid-search #gridSearch style="flex-grow: 1"
                             placeholder="Search key(s)"
                             [grid]="grid">
        </wj-flex-grid-search>
        <div style="white-space: nowrap">Showing {{AppFormat.formatInteger(12)}} items</div>
    </div>
</div>
